var map = {
	"./footer-logo-cn.png": "4529",
	"./footer-logo-en.png": "a4a5",
	"./footer-logo-ja.png": "1c92",
	"./footer-logo-ko.png": "b769",
	"./footer-logo-th.png": "39dc",
	"./footer-logo-tw.png": "499f",
	"./footer-logo-ug.png": "0ef4",
	"./footer-logo-vn.png": "da2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59f3";